<!--====== footer PART START ======-->
<footer class="footer-area footer-area-2 footer-area-1 bg_cover"
  style="background-image: url(assets/images/footer-bg.jpg);">
  <div class="footer-overlay">
    <div class="container position-relative">
      <div class="row">
        <div class="col-lg-3 col-md-3 col-sm-6 col-xs-6">
          <div class="widget-item-1 mt-30">
            <h6 class="title"> Information & contact</h6>
            <img class="logo" src="assets/images/logo.png" alt="">
            <p *ngIf="currentFiliale">{{currentFiliale?.adresse}} , ({{currentFiliale?.code}})</p>
            <p *ngIf="currentFiliale">{{currentFiliale?.telephone}}</p>
            <p *ngIf="currentFiliale?.telephone1">{{currentFiliale?.telephone1}}</p>
            <p *ngIf="!currentFiliale">Sacré Cœur Pyrotechnique , Dakar (SN)</p>
            <p *ngIf="!currentFiliale">+ 221 33 864 54 55</p>
            <p>contact@inclusiveguarantee.fr</p>
          </div> <!-- widget item 1 -->
        </div>
        <div class="col-lg-3 col-md-3 col-sm-6 col-xs-6">
          <div class="widget-item-1 mt-30">
            <h6 class="title">Offres d'assurances</h6>
            <div class="footer-list">
              <ul>
                <li><a routerLink='/sante' (click)="getRoute('','sante')"><i class="fal fa-angle-right"></i> Santé</a>
                </li>
                <li><a routerLink='/multirisque' (click)="getRoute('','multirisque')"><i class="fal fa-angle-right"></i>
                    Multirisque</a></li>
                <li><a routerLink='/auto' (click)="getRoute('','auto')"><i class="fal fa-angle-right"></i> Auto</a></li>
                <li><a routerLink='/voyage' (click)="getRoute('','voyage')"><i class="fal fa-angle-right"></i>
                    Voyage</a></li>
                <!-- <li><a href="#"><i class="fal fa-angle-right"></i> Voyage</a></li> -->
                <li><a routerLink='/vie' (click)="getRoute('','vie')"><i class="fal fa-angle-right"></i> Vie</a></li>
                <!-- <li><a routerLink='/accident-individuel' (click)="getRoute('','accident')"><i
                      class="fal fa-angle-right"></i> Individuelle Accidents </a></li> -->
              </ul>

            </div>
          </div> <!-- widget item 2 -->
        </div>
        <div class="col-lg-3 col-md-3 col-sm-6 col-xs-6">
          <div class="widget-item-1  mt-30">
            <h6 class="title">Liens utiles</h6>
            <div class="footer-list">
              <ul>
                <li><a href="http://www.inclusiveguarantee.fr/inclusive-guarantee" target="_blank"><i
                      class="fal fa-angle-right"></i> A propos</a></li>
                <li><a href="http://www.inclusiveguarantee.fr/notre-equipe-1" target="_blank"><i
                      class="fal fa-angle-right"></i> Carrières</a></li>
                <!-- <li><a href="#"><i class="fal fa-angle-right"></i> Nous recrutons</a></li> -->
              </ul>

            </div>
          </div> <!-- widget item 3 -->
        </div>
        <div class="col-lg-3 col-md-3 col-sm-6 col-xs-6">
          <div class="widget-item-1  mt-30">
            <h6 class="title">Espace assuré</h6>
            <div class="footer-list">
              <ul>
                <li><a [href]="adminAppUrl" target="_blank"><i class="fal fa-angle-right"></i> Devenir assuré</a></li>
                <li><a [href]="adminAppUrl" target="_blank"><i class="fal fa-angle-right"></i> Accéder à mon espace
                    partenaire</a></li>
                <!-- <li><a href="#"><i class="fal fa-angle-right"></i> Déclarer un sinistre</a></li> -->
              </ul>

            </div>
          </div>
        </div>
      </div> <!-- row -->
      <div class="row">
        <div class="col-lg-12">
          <div class="support pb-120">
            <div class="image" (click)="initRappel()" data-toggle="modal" data-target="#modalRappel"
              popover="Me faire rappeler" placement="top" triggers="mouseenter:mouseleave"><img
                src="assets/images/support.svg" /></div>
            <div class="image" (click)="initSinistre()" data-toggle="modal" data-target="#modalSinistre"
              popover="Faire un suivi de sinistre" placement="top" triggers="mouseenter:mouseleave"><img
                src="assets/images/chatboot.svg" /></div>
          </div>
        </div>
      </div>

      <!-- <div class="row justify-content-start">
        <div class="col-lg-4"></div>
        <div class="col-lg-4"></div>
        <app-chat class="col-lg-4"></app-chat>
      </div> -->
      <div class="row">
        <div class="col-lg-12">
          <div class="footer-copyright row">
            <p class="col-md-6 col-sm-6 col-xs-6">© 2020 <span class="copyright"> Copyright inclusive Guarantee</span>
            </p>
            <p class="mention col-md-6 col-sm-6 col-xs-6">Mentions légales - Assistance & supports</p>
          </div> <!-- footer copyright -->
        </div>
      </div> <!-- row -->
    </div> <!-- container -->
  </div>
  <div class="modal" id="modalRappel" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
    aria-hidden="true">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Me faire rappeler</h5>
          <button #closeBTNRappel type="button" class="close" data-dismiss="modal"
            (clikc)='firstClick=false;'>&times;</button>
        </div>
        <div class="modal-body">
          <div class="formulaire no-margin">
            <div class="row">
              <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                <form [formGroup]="formRappel">
                  <div *ngFor="let item of fieldsRappel">
                    <div class="input-box" *ngIf="item.type=='text' && !item?.chieldOther">
                      <input type="text" name={{item.field}} [formControlName]="item.field" [placeholder]="item.label">
                      <span class="img-form" [popover]="item.label" placement="top" triggers="mouseenter:mouseleave">
                        <img [src]="item.icon" alt="">
                      </span>
                    </div>
                    <div *ngIf="item.type=='text' && item?.chieldOther">
                      <div class="input-box"
                        *ngIf="formRappel.get(item.chieldOther.name).value==item.chieldOther.value">
                        <input type="text" value="{{formRappel.get(item.field).value}}" readonly name={{item.field}}
                          [formControlName]="item.field" [placeholder]="item.label">
                        <span class="img-form" [popover]="item.label" placement="top" triggers="mouseenter:mouseleave">
                          <img [src]="item.icon" alt="">
                        </span>
                      </div>
                    </div>
                    <div class="input-box" *ngIf="item.type=='number'  && !item?.chieldOther">
                      <input type="number" numberOnly name={{item.field}} [formControlName]="item.field"
                        [placeholder]="item.label">
                      <span class="img-form" [popover]="item.label" placement="top" triggers="mouseenter:mouseleave">
                        <img [src]="item.icon" alt="">
                      </span>
                    </div>

                    <div *ngIf="item.type=='number'  && item?.chieldOther">
                      <div class="input-box"
                        *ngIf="formRappel.get(item.chieldOther.name).value==item.chieldOther.value">
                        <input type="number" numberOnly name={{item.field}} [formControlName]="item.field"
                          [placeholder]="item.label">
                        <span class="img-form" [popover]="item.label" placement="top" triggers="mouseenter:mouseleave">
                          <img [src]="item.icon" alt="">
                        </span>
                      </div>
                    </div>


                    <div class="input-box" *ngIf="item.type=='montant' && !item?.chieldOther">
                      <input type="text" mask="separator" numberOnly name={{item.field}} [formControlName]="item.field"
                        [placeholder]="item.label">
                      <span class="img-form" [popover]="item.label" placement="top" triggers="mouseenter:mouseleave">
                        <img [src]="item.icon" alt="">
                      </span>
                    </div>

                    <div *ngIf="item.type=='montant' && item?.chieldOther">
                      <div class="input-box"
                        *ngIf="formRappel.get(item.chieldOther.name).value==item.chieldOther.value">
                        <input type="text" mask="separator" numberOnly name={{item.field}}
                          [formControlName]="item.field" [placeholder]="item.label">
                        <span class="img-form" [popover]="item.label" placement="top" triggers="mouseenter:mouseleave">
                          <img [src]="item.icon" alt="">
                        </span>
                      </div>
                    </div>
                    <div class="input-box" *ngIf="item.type=='tel' && !item?.chieldOther ">
                      <input type="text" numberOnly class="input-tel" name={{item.field}} [formControlName]="item.field"
                        [placeholder]="item.label" ng2TelInput [ng2TelInputOptions]="{initialCountry: 'sn'}" clearInput
                        (focus)="isFocus=true" (blur)="isFocus=false" (hasError)="hasError($event,item.field,'formRappel')"
                        (ng2TelOutput)="getNumber($event,item.field,'formRappel')"
                        (intlTelInputObject)="telInputObject($event)" (countryChange)="onCountryChange($event)"/>
                    </div>

                    <div
                      *ngIf="item.type=='tel' && formRappel.get(item.field).value && isFocus===false && hasPhoneError"
                      class="text-red">
                      {{item.label}} est invalide
                    </div>
                    <div class="input-box" *ngIf="item.type=='email' && !item?.chieldOther">
                      <input type="email" name={{item.field}} [formControlName]="item.field" [placeholder]="item.label">
                      <span class="img-form" [popover]="item.label" placement="top" triggers="mouseenter:mouseleave">
                        <img [src]="item.icon" alt="">
                      </span>
                    </div>

                    <div class="input-box" *ngIf="item.type=='select' && !item?.chieldOther">
                      <select name={{item.field}} [formControlName]="item.field">
                        <option value="" disabled selected> {{item.label}} </option>
                        <option *ngFor="let val of item?.list" value="{{val.value}}"> {{val.name}} </option>
                      </select>
                      <span class="img-form" [popover]="item.label" placement="top" triggers="mouseenter:mouseleave">
                        <img [src]="item.icon" alt="">
                      </span>
                    </div>
                    <div *ngIf="item.type=='select' && item?.chieldOther">
                      <div class="input-box"
                        *ngIf="formRappel.get(item.chieldOther.name).value==item.chieldOther.value">
                        <select name={{item.field}} [formControlName]="item.field">
                          <option value="" disabled selected> {{item.label}} </option>
                          <option *ngFor="let val of item?.list" value="{{val.value}}"> {{val.name}} </option>
                        </select>
                        <span class="img-form" [popover]="item.label" placement="top" triggers="mouseenter:mouseleave">
                          <img [src]="item.icon" alt="">
                        </span>
                      </div>
                    </div>
                    <div class="error-input" *ngFor="let validation of item.validations;">
                      <div
                        *ngIf="formRappel.get(item.field).invalid && (formRappel.get(item.field).dirty || formRappel.get(item.field).touched || firstClick)">
                        <div class="text-red" *ngIf="formRappel.get(item.field).hasError(validation.name) ">
                          {{validation.message}}
                        </div>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
          <div class="plainteBtn">
            <button class="btn btn-danger" data-dismiss="modal" [disabled]="loader"
              (clikc)='firstClick=false;'>Annuler</button>
            <button class="btn btn-success" [disabled]="loader" (click)="checkFormRappel()"> <i
                class="fal fa-spinner fa-pulse" *ngIf="loader"></i> &nbsp; Envoyer</button>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="modal" id="modalSinistre" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
    aria-hidden="true">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Suivi sinistre</h5>
          <button #closeBTNRappel type="button" class="close" data-dismiss="modal"
            (clikc)='firstClick=false;'>&times;</button>
        </div>
        <div class="modal-body">
          <div class="title-sinistre">
            Veuillez remplir le formulaire pour faire un suivi de votre sinistre
          </div>
          <div class="formulaire no-margin">
            <div class="row">
              <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                <form [formGroup]="formSinistre">
                  <div *ngFor="let item of fieldsSinistre">
                    <div class="input-box" *ngIf="item.type=='text'">
                      <input type="text" name={{item.field}} [formControlName]="item.field" [placeholder]="item.label">
                      <span class="img-form" [popover]="item.label" placement="top" triggers="mouseenter:mouseleave">
                        <img [src]="item.icon" alt="">
                      </span>
                    </div>
                    <div class="input-box" *ngIf="item.type=='number'">
                      <input type="text" numberOnly name={{item.field}} [formControlName]="item.field"
                        [placeholder]="item.label">
                      <span class="img-form" [popover]="item.label" placement="top" triggers="mouseenter:mouseleave">
                        <img [src]="item.icon" alt="">
                      </span>
                    </div>
                    <div class="input-box" *ngIf="item.type=='tel'">
                      <input type="text" numberOnly class="input-tel" name={{item.field}} [formControlName]="item.field"
                        [placeholder]="item.label" ng2TelInput [ng2TelInputOptions]="{initialCountry: 'sn'}" clearInput
                        (focus)="isFocus=true" (blur)="isFocus=false" (hasError)="hasError($event,item.field,'formSinistre')"
                        (ng2TelOutput)="getNumber($event,item.field,'formSinistre')"
                        (intlTelInputObject)="telInputObject($event)" (countryChange)="onCountryChange($event)" />
                    </div>

                    <div
                      *ngIf="item.type=='tel' && formSinistre.get(item.field).value && isFocus===false && hasPhoneError"
                      class="text-red">
                      {{item.label}} est invalide
                    </div>
                    <div class="error-input" *ngFor="let validation of item.validations;">
                      <div
                        *ngIf="formSinistre.get(item.field).invalid && (formSinistre.get(item.field).dirty || formSinistre.get(item.field).touched || firstClick)">
                        <div class="text-red" *ngIf="formSinistre.get(item.field).hasError(validation.name) ">
                          {{validation.message}}
                        </div>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
          <div class="plainteBtn">
            <button class="btn btn-danger" data-dismiss="modal" [disabled]="loader"
              (clikc)='firstClick=false;'>Annuler</button>
            <button class="btn btn-success" [disabled]="loader" (click)="checkFormSinistre()"> <i
                class="fal fa-spinner fa-pulse" *ngIf="loader"></i> &nbsp; Envoyer</button>
          </div>
        </div>
        <div class="detailsSuivi" *ngIf="infoSinistre">
          <div class="title-suivi">
            Détails du sinistre
          </div>
          <div class="info-sinsitre">
            <div class="row">
              <div class="col-6">
                <div class="key">
                  Nom:
                </div>
                <div class="value">
                  {{infoSinistre?.nom}}
                </div>
              </div>
              <div class="col-6">
                <div class="key">
                  Prénom:
                </div>
                <div class="value">
                  {{infoSinistre?.prenom}}
                </div>
              </div>
              <div class="col-6">
                <div class="key">
                  Email:
                </div>
                <div class="value">
                  {{infoSinistre?.email}}
                </div>
              </div>
              <div class="col-6">
                <div class="key">
                  Téléphone:
                </div>
                <div class="value">
                  {{infoSinistre?.telephone}}
                </div>
              </div>
              <div class="col-12">
                <div class="key">
                  Description:
                </div>
                <div class="value">
                  {{infoSinistre?.description}}
                </div>
              </div>
              <div class="col-12">
                <div class="badge badge-info" *ngIf="infoSinistre?.statut=='En attente'">
                 Votre déclaration de sinistre est en attente de traitement
                </div>
                <div class="badge badge-warning" *ngIf="infoSinistre?.statut=='En cours'">
                  Votre déclaration de sinistre est en cours de traitement
                 </div>
                 <div class="badge badge-primary" *ngIf="infoSinistre?.statut=='Valider'">
                  Votre déclaration de sinistre a été accepté
                 </div>
                 <div class="badge badge-success" *ngIf="infoSinistre?.statut=='Reglement'">
                  Le paiement a été effectué pour votre déclaration de sinistre
                 </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <swal #confirmSwalRappel title="Voulez-vous confirmer les informations saisies" text="" icon="question"
    [showCancelButton]="true" [confirmButtonText]="'Valider'" [cancelButtonText]="'Annuler'"
    [showLoaderOnConfirm]="true" [allowEscapeKey]="false" [allowOutsideClick]="false" (confirm)="saveRappel()">
  </swal>
  <swal #confirmSwalSinistre title="Voulez-vous confirmer les informations saisies" text="" icon="question"
    [showCancelButton]="true" [confirmButtonText]="'Valider'" [cancelButtonText]="'Annuler'"
    [showLoaderOnConfirm]="true" [allowEscapeKey]="false" [allowOutsideClick]="false" (confirm)="checkSuiviSinistre()">
  </swal>
</footer>
<!--====== footer PART ENDS ======-->
<!--====== BACK TO TOP ======-->
<div class="back-to-top back-to-top-2">
  <a href="">
    <i class="fas fa-arrow-up"></i>
  </a>
</div>
<!--====== BACK TO TOP ======-->
